import { motion } from "framer-motion";
import React from "react";
import { AuroraBackground } from "@/components/ui/aurora-background";
import { Button } from "@/components/ui/button";
import { ArrowRight, MapPin, Clock } from "lucide-react";

export function AuroraBackgroundDemo() {
  return (
    <AuroraBackground>
      <motion.div
        initial={{ opacity: 0.0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{
          delay: 0.3,
          duration: 0.8,
          ease: "easeInOut",
        }}
        className="relative flex flex-col gap-4 items-center justify-center px-4 pt-24 z-10"
      >
        <div className="text-5xl md:text-6xl lg:text-7xl font-bold font-poppins text-foreground dark:text-white text-center mb-6">
          Transforme seu Fluig em uma
          <span className="block fs-gradient-text mt-2">
            máquina de produtividade
          </span>
        </div>

        <div className="text-xl md:text-2xl text-foreground/80 dark:text-white/80 text-center max-w-3xl mb-8">
          Você já tem as licenças. Nós criamos os processos digitais que faltam para seus departamentos ganharem tempo, eficiência e resultados.
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 max-w-xl w-full">
          <div className="text-center bg-card/50 backdrop-blur-sm border border-border/50 rounded-2xl p-6">
            <div className="flex items-center justify-center mb-2">
              <MapPin className="w-5 h-5 text-fs-cyan-400 mr-2" />
              <span className="text-3xl font-bold text-foreground dark:text-white">4</span>
            </div>
            <p className="text-muted-foreground dark:text-white/70 text-sm">Capitais atendidas</p>
          </div>

          <div className="text-center bg-card/50 backdrop-blur-sm border border-border/50 rounded-2xl p-6">
            <div className="flex items-center justify-center mb-2">
              <Clock className="w-5 h-5 text-fs-magenta-400 mr-2" />
              <span className="text-3xl font-bold text-foreground dark:text-white">10+</span>
            </div>
            <p className="text-muted-foreground dark:text-white/70 text-sm">Anos de experiência</p>
          </div>
        </div>

        <Button variant="fs-primary" size="xl" className="group">
          Explorar agora
          <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
        </Button>

        {/* Trust Indicators */}
        <div className="mt-8 pt-6 border-t border-border/50">
          <p className="text-muted-foreground dark:text-white/70 text-sm mb-4">Confiado por empresas de todos os portes</p>
          <div className="flex items-center justify-center space-x-8 opacity-60">
            <div className="text-muted-foreground dark:text-white/70 text-xs font-medium">CERTIFICADOS FLUIG</div>
            <div className="text-muted-foreground dark:text-white/70 text-xs font-medium">ISO 9001</div>
          </div>
        </div>
      </motion.div>
    </AuroraBackground>
  );
}
